/*
 * 微博 - 热搜榜（服务端路由）
 */
export async function fetchWeiboHot() {
  const res = await fetch('/server-api/weibo')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
